module.exports = __webpack_public_path__ + "static/img/clogo.f40a12f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/led/clogo.png
// module id = sW99
// module chunks = 4